import React, { useState } from 'react';
import {
  buildStreakShareMessage,
  buildViralInviteUrl,
  buildLineShareUrl,
  recordShare,
} from 'viral/viralShare';

export default function ShareStreakBadge({ streak }) {
  const [copied, setCopied] = useState(false);

  if (!streak || streak < 2) return null;

  const text = buildStreakShareMessage(streak);
  const url = buildViralInviteUrl('streak');
  const lineUrl = buildLineShareUrl(text, url);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${text}\n${url}`);
      recordShare('streak');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="share-streak" role="status">
      <p className="share-streak__text">
        🔥 สตรีค {streak} วัน! ภูมิใจไหม? ชวนเพื่อนมาแข่งกัน
      </p>
      <div className="share-streak__actions">
        <button type="button" className="share-streak__btn" onClick={handleCopy}>
          {copied ? 'คัดลอกแล้ว ✓' : 'แชร์สตรีค'}
        </button>
        <a
          href={lineUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="share-streak__btn share-streak__btn--line"
          onClick={() => recordShare('streak_line')}
        >
          ส่ง LINE
        </a>
      </div>
    </div>
  );
}
